import { render, staticRenderFns } from "./AllPaymentDisputes.vue?vue&type=template&id=90c6cf2a&"
import script from "./AllPaymentDisputes.vue?vue&type=script&lang=js&"
export * from "./AllPaymentDisputes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports